<template>
  <v-container fluid class="pa-0 fill-height align-start">
    <v-card width="100%" min-height="100vh" flat dark>
      <!-- Navigation / Header (Search View) -->
      <v-toolbar v-if="false && currentView === 'search'" flat color="#1E1E1E" class="border-bottom">
        <v-toolbar-title class="font-weight-bold pl-2"> <span class="primary--text">TAC</span> Member Manager </v-toolbar-title>
      </v-toolbar>

      <v-main class="pa-0">
        <!-- VIEW: SEARCH -->
        <v-fade-transition mode="out-in">
          <div v-if="currentView === 'search'" key="search" class="pa-4">
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <v-card class="rounded-xl elevation-10" color="#1E1E1E">
                  <v-card-title class="text-h5 font-weight-light pt-6 px-6"> Mitglied suchen </v-card-title>
                  <v-card-text class="px-6 pb-6">
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="searchValues.FirstName"
                          label="Vorname"
                          outlined
                          dense
                          hide-details="auto"
                          class="rounded-lg"
                          @keyup.enter="performSearch"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="searchValues.LastName"
                          label="Nachname"
                          outlined
                          dense
                          hide-details="auto"
                          class="rounded-lg"
                          @keyup.enter="performSearch"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="searchValues.EMail"
                          label="E-Mail"
                          outlined
                          dense
                          hide-details="auto"
                          class="rounded-lg"
                          @keyup.enter="performSearch"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-4">
                      <v-col cols="12" class="d-flex justify-space-between">
                        <v-btn text color="grey" @click="resetSearch"> <v-icon left>mdi-refresh</v-icon> Reset </v-btn>
                        <div class="d-flex gap-2">
                          <v-btn v-if="false" color="success" outlined class="mr-2" @click="createNewUser">
                            <v-icon left>mdi-account-plus</v-icon> Neu erstellen
                          </v-btn>
                          <v-btn color="primary" depressed :loading="searching" @click="performSearch">
                            <v-icon left>mdi-magnify</v-icon> Suchen
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Search Results -->
                <v-card v-if="profileResults.length > 0" class="mt-6 rounded-xl elevation-5" color="#1E1E1E">
                  <v-card-title class="subtitle-1 font-weight-bold"> Suchergebnisse ({{ profileResults.length }}) </v-card-title>
                  <v-list two-line bg-color="transparent" color="transparent">
                    <template v-for="(item, index) in profileResults">
                      <v-list-item :key="index" @click="selectUser(item)">
                        <v-list-item-avatar color="primary darken-2">
                          <span class="white--text text-h6 ma-auto">{{ item.Customer.PersonName.FirstName.charAt(0) }}</span>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ item.Customer.PersonName.FirstName }} {{ item.Customer.PersonName.LastName }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-icon x-small color="grey">mdi-map-marker</v-icon>
                            {{ getAddressString(item) }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <span class="caption grey--text">TAC ID: {{ getProfileID(item) }}</span> |
                            <span class="caption grey--text">{{ $moment(item.Customer.birthDate).format("DD.MM.YYYY") }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon>
                            <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="index < profileResults.length - 1" :key="'div-' + index" inset></v-divider>
                    </template>
                  </v-list>
                </v-card>
                <v-alert v-if="searchPerformed && profileResults.length === 0" type="info" class="mt-4" text> Keine Ergebnisse gefunden. </v-alert>
              </v-col>
            </v-row>
          </div>

          <!-- VIEW: DETAILS / DASHBOARD -->
          <div v-else-if="currentView === 'details'" key="details" class="fill-height">
            <!-- HEADER (AiMail Style) -->
            <div class="d-flex align-end pa-6 gradient-header sticky-header">
              <v-btn icon large color="white" class="mb-2 mr-4" @click="goBack">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>

              <v-avatar size="72" color="white" class="elevation-4 mr-5">
                <span class="primary--text text-h4 font-weight-black">{{ getUserInitials() }}</span>
              </v-avatar>

              <div class="mb-1">
                <div class="text-h4 font-weight-bold white--text">{{ getFullName() }}</div>
                <v-chip label x-small color="rgba(255,255,255,0.1)" class="font-weight-bold letter-spacing-1 mr-2">
                  ID: {{ mappedData ? mappedData.memberNumber : getProfileID(selectedUser) }}
                </v-chip>
                <v-chip v-if="roodyUser" label x-small color="green darken-3" class="font-weight-bold letter-spacing-1"> ROODY VERKNÜPFT </v-chip>
                <v-chip v-else label x-small color="grey darken-3" class="font-weight-bold letter-spacing-1"> KEIN ROODY KONTO </v-chip>
              </div>
              <v-spacer></v-spacer>
            </div>

            <!-- TABS -->
            <v-tabs v-model="activeTab" dark grow height="60" slider-color="primary">
              <v-tab class="font-weight-bold text-capitalize"><v-icon left small>mdi-view-dashboard</v-icon> Übersicht</v-tab>
              <v-tab class="font-weight-bold text-capitalize"
                ><v-icon left small>mdi-file-document-multiple</v-icon> Verträge
                <span v-if="mappedData" class="ml-1">({{ mappedData.contracts.length }})</span></v-tab
              >
              <v-tab class="font-weight-bold text-capitalize"><v-icon left small>mdi-note-text</v-icon> Notizen</v-tab>
              <v-tab v-show="false" class="font-weight-bold text-capitalize">Bearbeiten</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab" class="transparent pa-6" style="min-height: 400px; background: #000">
              <!-- TAB 1: ÜBERSICHT -->
              <v-tab-item>
                <v-row v-if="loadingContracts">
                  <v-col cols="12" class="text-center py-5">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-col>
                </v-row>

                <v-row v-else-if="mappedData">
                  <v-col cols="12" md="6">
                    <v-card flat color="#161616" class="pa-5 rounded-xl fill-height border-subtle">
                      <div class="overline grey--text mb-4 font-weight-bold">FINANZEN</div>

                      <div class="d-flex align-center justify-space-between mb-4">
                        <span class="grey--text text--lighten-1">Saldo Gesamt</span>
                        <span
                          class="text-h4 font-weight-black"
                          :class="parseFloat(mappedData.balanceTotal) < 0 ? 'red--text text--accent-2' : 'green--text text--accent-3'">
                          CHF {{ mappedData.balanceTotal }}
                        </span>
                      </div>

                      <v-divider class="grey darken-4 mb-4"></v-divider>

                      <div class="d-flex justify-space-between mb-2">
                        <span class="grey--text">Abo-Konto</span>
                        <span class="white--text font-weight-bold">CHF {{ mappedData.balanceMembership }}</span>
                      </div>

                      <div class="d-flex justify-space-between mb-4">
                        <span class="grey--text">Konsum-Konto</span>
                        <span class="white--text font-weight-bold">CHF {{ mappedData.balanceConsumption }}</span>
                      </div>

                      <v-divider class="grey darken-4 mb-4"></v-divider>

                      <div class="d-flex justify-space-between align-center">
                        <span class="caption grey--text">Transaktionen</span>
                        <v-btn x-small text color="primary" @click="showTransactionsDialog = true">Anzeigen</v-btn>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card flat color="#161616" class="pa-5 rounded-xl fill-height border-subtle">
                      <div class="d-flex justify-space-between align-center mb-4">
                        <div class="overline grey--text font-weight-bold">KONTAKT</div>
                        <v-btn icon x-small color="grey" @click="activeTab = 3"><v-icon>mdi-pencil</v-icon></v-btn>
                      </div>

                      <div class="d-flex align-center mb-3">
                        <v-icon small color="primary" class="mr-3">mdi-email</v-icon>
                        <span class="body-1 white--text">{{ mappedData.email }}</span>
                      </div>

                      <div class="d-flex align-center mb-3">
                        <v-icon small color="primary" class="mr-3">mdi-phone</v-icon>
                        <span class="body-1 white--text">{{ mappedData.phone }}</span>
                      </div>

                      <div class="d-flex align-start mb-3">
                        <v-icon small color="primary" class="mr-3 mt-1">mdi-map-marker</v-icon>
                        <span class="body-1 white--text">{{ mappedData.address }}, {{ mappedData.zipCity }}</span>
                      </div>

                      <div class="d-flex align-center">
                        <v-icon small color="grey" class="mr-3">mdi-calendar-account</v-icon>
                        <span class="body-2 grey--text">Geboren am {{ $moment(mappedData.birthDate).format("DD.MM.YYYY") }}</span>
                      </div>
                    </v-card>
                  </v-col>

                  <!-- NEW: Active Contracts in Overview -->
                  <v-col cols="12">
                    <div class="overline grey--text mb-2 font-weight-bold pl-1">AKTIVE VERTRÄGE</div>
                    <div
                      v-if="mappedData.contracts.filter((c) => c.statusCode === 1 || c.statusCode === 2).length === 0"
                      class="caption grey--text pl-1">
                      Keine aktiven Verträge.
                    </div>
                    <div v-else>
                      <div
                        v-for="(contract, i) in mappedData.contracts.filter((c) => c.statusCode === 1 || c.statusCode === 2)"
                        :key="'active-' + i"
                        class="mb-3">
                        <v-card flat color="#161616" class="rounded-xl border-subtle overflow-hidden">
                          <div class="pa-4 d-flex align-center" :style="`border-left: 4px solid ${contract.color}`">
                            <div>
                              <div class="font-weight-bold white--text subtitle-1">{{ contract.name }}</div>
                              <div class="caption grey--text">{{ contract.start }} - {{ contract.end }}</div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-chip x-small :color="contract.color" label class="font-weight-bold white--text mr-2">{{ contract.statusText }}</v-chip>
                          </div>
                          <div v-if="contract.subContracts && contract.subContracts.length" class="px-4 pb-4">
                            <v-divider class="grey darken-4 mb-3"></v-divider>
                            <div v-for="(sub, k) in contract.subContracts" :key="k" class="d-flex align-center mb-1">
                              <v-icon x-small color="grey" class="mr-2">mdi-plus-circle-outline</v-icon>
                              <span class="caption white--text">{{ sub.name }}</span>
                              <v-spacer></v-spacer>
                              <span class="caption grey--text">{{ sub.statusText }}</span>
                            </div>
                          </div>
                        </v-card>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" v-if="mappedData.checkins && mappedData.checkins.length > 0">
                    <v-card flat color="#161616" class="pa-5 rounded-xl border-subtle">
                      <div class="overline grey--text mb-4 font-weight-bold">LETZTE ZUTRITTE</div>
                      <div class="d-flex flex-wrap gap-2">
                        <v-chip v-for="(checkin, i) in mappedData.checkins.slice(0, 5)" :key="i" color="grey darken-3" label small class="mr-2 mb-2">
                          {{ $moment(checkin).format("DD.MM.YY HH:mm") }}
                        </v-chip>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-alert v-else type="info" text class="mt-4">Lade Daten...</v-alert>
              </v-tab-item>

              <!-- TAB 2: VERTRÄGE -->
              <v-tab-item>
                <div v-if="mappedData">
                  <div v-for="(contract, i) in mappedData.contracts" :key="i" class="mb-4">
                    <v-card flat color="#161616" class="rounded-xl border-subtle overflow-hidden">
                      <div class="pa-4 d-flex align-center" :style="`border-left: 4px solid ${contract.color}`">
                        <div>
                          <div class="font-weight-bold white--text subtitle-1">{{ contract.name }}</div>
                          <div class="caption grey--text">{{ contract.start }} - {{ contract.end }}</div>
                          <div v-if="contract.terminationReason" class="caption red--text mt-1">Gekündigt: {{ contract.terminationReason }}</div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-chip x-small :color="contract.color" label class="font-weight-bold white--text mr-2">{{ contract.statusText }}</v-chip>

                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn color="white" icon small v-bind="attrs" v-on="on"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                          </template>
                          <v-list dense dark color="#333">
                            <v-list-item @click="initiateTermination(contract)">
                              <v-list-item-icon><v-icon small color="red">mdi-cancel</v-icon></v-list-item-icon>
                              <v-list-item-title class="red--text">Kündigen</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>

                      <div v-if="contract.subContracts && contract.subContracts.length" class="px-4 pb-4">
                        <v-divider class="grey darken-4 mb-3"></v-divider>
                        <div v-for="(sub, k) in contract.subContracts" :key="k" class="d-flex align-center mb-1">
                          <v-icon x-small color="grey" class="mr-2">mdi-plus-circle-outline</v-icon>
                          <span class="caption white--text">{{ sub.name }}</span>
                          <v-spacer></v-spacer>
                          <span class="caption grey--text">{{ sub.statusText }}</span>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
              </v-tab-item>

              <!-- TAB 3: NOTIZEN -->
              <v-tab-item>
                <v-card flat color="#161616" class="rounded-xl pa-0 overflow-hidden fill-height border-subtle d-flex flex-column" min-height="500">
                  <v-tabs v-model="activeNoteTypeIndex" background-color="transparent" dark slider-color="primary" dense show-arrows>
                    <v-tab v-for="type in noteTypes" :key="type" class="caption font-weight-bold">
                      {{ type }}
                    </v-tab>
                  </v-tabs>

                  <v-divider class="grey darken-4"></v-divider>

                  <div class="pa-4 flex-grow-1">
                    <div class="d-flex align-center justify-space-between mb-2">
                      <span class="caption grey--text">
                        Inhalt für <strong>{{ currentNoteType }}</strong>
                      </span>
                      <span class="caption grey--text text--darken-1"> Zuletzt: {{ getLastCommentDate() }} </span>
                    </div>

                    <v-textarea
                      v-model="currentNoteText"
                      outlined
                      dense
                      dark
                      rows="12"
                      background-color="#0a0a0a"
                      :placeholder="`Notizen für ${currentNoteType} hier eingeben...`"
                      hide-details
                      class="font-mono body-2"></v-textarea>

                    <div class="d-flex justify-end mt-4">
                      <v-btn color="primary" depressed class="rounded-lg" :loading="savingComment" @click="saveCurrentNote">
                        <v-icon left small>mdi-content-save</v-icon> {{ currentNoteType }} Speichern
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>

              <!-- TAB 4: BEARBEITEN (Legacy Form, hidden from tab header but accessible via index 3) -->
              <v-tab-item>
                <div class="d-flex align-center mb-4 px-2">
                  <v-btn icon small @click="activeTab = 0" class="mr-2"><v-icon>mdi-arrow-left</v-icon></v-btn>
                  <span class="text-h6 font-weight-bold">Profil bearbeiten</span>
                </div>
                <v-card color="#161616" class="rounded-xl pa-4 border-subtle" flat>
                  <v-form ref="profileForm" v-model="validProfile">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          label="Anrede"
                          :items="['Herr', 'Frau']"
                          v-model="editUserData.Customer.PersonName.Salutation"
                          outlined
                          dense
                          dark></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-select
                          label="Geschlecht"
                          :items="['MALE', 'FEMALE']"
                          v-model="editUserData.Customer.gender"
                          outlined
                          dense
                          dark></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          label="Vorname"
                          v-model="editUserData.Customer.PersonName.FirstName"
                          outlined
                          dense
                          dark
                          :rules="[(v) => !!v || 'Erforderlich']"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          label="Nachname"
                          v-model="editUserData.Customer.PersonName.LastName"
                          outlined
                          dense
                          dark
                          :rules="[(v) => !!v || 'Erforderlich']"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          label="Kundenkonto (Account Name)"
                          v-model="editUserData.Customer.AccountName"
                          outlined
                          dense
                          dark></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="Geburtstag" type="date" v-model="editUserData.Customer.birthDate" outlined dense dark></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="E-Mail" v-model="getEmailObj().PhoneData.PhoneNumber" outlined dense dark></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="Mobil" v-model="getMobileObj().PhoneData.PhoneNumber" outlined dense dark></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field label="Strasse" v-model="getAddressObj().AddressLine1" outlined dense dark></v-text-field>
                      </v-col>
                      <v-col cols="4" md="2">
                        <v-text-field label="PLZ" v-model="getAddressObj().PostalCode" outlined dense dark></v-text-field>
                      </v-col>
                      <v-col cols="8" md="4">
                        <v-text-field label="Ort" v-model="getAddressObj().CityName" outlined dense dark></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-select
                          label="Land"
                          :items="['CH', 'DE', 'AT', 'FR', 'IT']"
                          v-model="getAddressObj().CountryCode"
                          outlined
                          dense
                          dark></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="d-flex justify-end">
                        <v-btn color="primary" depressed large @click="saveProfile" :loading="savingProfile">
                          <v-icon left>mdi-content-save</v-icon> Änderungen Speichern
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-fade-transition>
      </v-main>

      <!-- DIALOGS -->

      <!-- Termination Wizard Dialog -->
      <v-dialog v-model="showTerminationDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card color="#121212" dark>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="showTerminationDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Kündigungs-Assistent</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="showTerminationDialog = false">Schliessen</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <mail-termination-wizard
              v-if="showTerminationDialog && selectedUser"
              :user="mapUserForWizard(selectedUser)"
              @completed="onTerminationCompleted"
              @cancel="showTerminationDialog = false"></mail-termination-wizard>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Transactions Dialog -->
      <v-dialog v-model="showTransactionsDialog" max-width="800px">
        <v-card color="#121212" dark>
          <v-card-title>Transaktionen</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="transactionHeaders"
              :items="transactions"
              :loading="loadingFinancials"
              dense
              dark
              class="elevation-1 rounded-lg"
              style="background-color: rgba(255, 255, 255, 0.02)">
              <template v-slot:item.valutaDate="{ item }">
                {{ formatDate(item.valutaDate) }}
              </template>
              <template v-slot:item.amount="{ item }">
                <span :class="item.amount < 0 ? 'green--text' : 'red--text'"> CHF {{ Math.abs(item.amount).toFixed(2) }} </span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showTransactionsDialog = false">Schliessen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api"
import tacApi from "@/api/tacApi"
import MailTerminationWizard from "@/components/ai/mailTerminationWizard"
import moment from "moment"

export default {
  name: "TacMemberManager",
  components: {
    MailTerminationWizard,
  },
  data: () => ({
    currentView: "search",
    activeTab: 0,

    // Search
    searchValues: {
      FirstName: "",
      LastName: "",
      EMail: "",
      ProfileID: "",
    },
    searching: false,
    searchPerformed: false,
    profileResults: [],

    // Selected User Data
    selectedUser: null,
    mappedData: null,
    editUserData: null,
    validProfile: true,
    savingProfile: false,
    roodyUser: null,

    // Comments / Notes
    noteTypes: ["Büro", "Allgemein", "Korrespondenz", "Fitness", "Karappa"],
    activeNoteTypeIndex: 0,
    currentNoteText: "",
    savingComment: false,

    // Contracts
    contracts: [], // Not used for view anymore, but logic ref
    loadingContracts: false,
    showTerminationDialog: false,
    showTransactionsDialog: false,

    // Financials
    loadingFinancials: false,
    // membershipBalance & secondarySpendBalance are now derived from mappedData in computed or watched/updated in load

    transactions: [],
    transactionHeaders: [
      { text: "Datum", value: "valutaDate" },
      { text: "Beschreibung", value: "description" },
      { text: "Betrag", value: "amount", align: "end" },
    ],
  }),
  computed: {
    currentNoteType() {
      return this.noteTypes[this.activeNoteTypeIndex]
    },
  },
  watch: {
    activeNoteTypeIndex() {
      this.loadCommentForType()
    },
  },
  methods: {
    getFullName() {
      if (this.mappedData) return this.mappedData.fullName
      return `${this.selectedUser.Customer.PersonName.FirstName} ${this.selectedUser.Customer.PersonName.LastName}`
    },
    getUserInitials() {
      if (this.mappedData) return this.mappedData.initials
      const f = this.selectedUser.Customer.PersonName.FirstName
      const l = this.selectedUser.Customer.PersonName.LastName
      return (f?.[0] || "") + (l?.[0] || "")
    },

    // --- UTILS FROM AIMAIL ---
    ensureArray(item) {
      if (!item) return []
      if (Array.isArray(item)) return item
      return [item]
    },
    getContractStatusTextMap(stateCode) {
      const states = {
        0: "PROVISORISCH",
        1: "AKTIV",
        2: "BALD AKTIV",
        3: "ABGELAUFEN",
        4: "GEKÜNDIGT",
        5: "BEENDET/STONIERT",
        6: "RUHEZEIT",
        7: "GESPERRT",
      }
      return states[stateCode] || `Status ${stateCode}`
    },
    getStatusColor(code) {
      if (code === 1 || code === 2) return "green"
      if (code === 6) return "orange"
      if (code === 7) return "red"
      return "grey"
    },
    mapTacMemberData(rawTacData) {
      if (!rawTacData || !rawTacData.MemberDetails || !rawTacData.MemberDetails.MemberDetail) {
        return null
      }
      try {
        const allDetails = this.ensureArray(rawTacData.MemberDetails.MemberDetail)
        // 1. Sortieren
        const sortedDetails = [...allDetails].sort((a, b) => {
          if (a.ContractState === 1 && b.ContractState !== 1) return -1
          if (b.ContractState === 1 && a.ContractState !== 1) return 1
          return new Date(b.ContractEndDate) - new Date(a.ContractEndDate)
        })

        let mainDetail = sortedDetails[0]
        let profileRoot = mainDetail.Profile || {}
        while (profileRoot.Profile) {
          profileRoot = profileRoot.Profile
        }
        const customer = profileRoot.Customer || {}
        const personName = customer.PersonName || {}
        const addresses = this.ensureArray(profileRoot.Addresses?.NameAddress)
        const mainAddress = addresses.find((a) => a.primary) || addresses[0]

        // 2. Finanzen
        let balMem = 0
        let balCons = 0
        const processedAccounts = new Set()
        allDetails.forEach((d) => {
          const accs = this.ensureArray(d.Accounts?.Account)
          accs.forEach((a) => {
            const id = a.AccountID?.UniqueID?.[0]?.value
            if (id && !processedAccounts.has(id)) {
              processedAccounts.add(id)
              const val = parseFloat(a.Balance?.value || 0)
              if (a.type === "MEMBERSHIP") balMem += val
              else balCons += val
            }
          })
        })

        // 3. Kommentare
        const comments = []
        this.ensureArray(profileRoot.Comments?.Comment).forEach((c) => {
          this.ensureArray(c.Text?.TextElement).forEach((t) => {
            if (t.value) comments.push({ type: c.commentType || "Info", text: t.value, updateDate: c.updateDate })
          })
        })

        // 4. Verträge
        const contracts = sortedDetails.map((d) => {
          const subs = this.ensureArray(d.SubContracts?.SubContract).map((sub) => ({
            name: sub.MemberCategoryName,
            statusText: this.getContractStatusTextMap(sub.ContractState),
            end: sub.ContractEndDate ? sub.ContractEndDate.split("T")[0] : "",
          }))
          return {
            name: d.MemberCategoryName || "Unbekannt",
            start: d.ContractStartDate ? d.ContractStartDate.split("T")[0] : "",
            end: d.ContractEndDate ? d.ContractEndDate.split("T")[0] : "",
            usageStart: d.UsageStartDate ? d.UsageStartDate.split("T")[0] : "",
            statusText: this.getContractStatusTextMap(d.ContractState),
            statusCode: d.ContractState,
            color: this.getStatusColor(d.ContractState),
            studioId: d.PropertyID?.UniqueID?.[0]?.value,
            renewalMode: d.RenewalMode,
            terminationReason: d.TerminationInfo?.TerminationReason,
            subContracts: subs,
            raw: d,
          }
        })

        // 5. Checkins
        // Assume rawTacData might have checkins if backend added them, otherwise leave empty
        // The API return said { userMembership, userMembershipAllData }
        // userMembershipAllData IS what we mapped.
        // If backend doesn't fetch checkins for this call, we won't have them.
        // Checkins usually come from a separate call fetchCheckinStatistic.
        // But we can check if they are in the obj.

        return {
          mapped: true,
          fullName: `${personName.Salutation || ""} ${personName.FirstName || ""} ${personName.LastName || ""}`.trim(),
          initials: (personName.FirstName?.[0] || "") + (personName.LastName?.[0] || ""),
          memberNumber: mainDetail.MemberNumber,
          email: customer.AccountName || "n/a", // often AccountName is email
          phone: this.getMobileObj()?.PhoneData?.PhoneNumber || "n/a", // Use local helper to get it safely
          address: mainAddress ? mainAddress.AddressLine1 : "",
          zipCity: mainAddress ? `${mainAddress.PostalCode} ${mainAddress.CityName}` : "",
          birthDate: customer.birthDate,

          balanceMembership: balMem.toFixed(2),
          balanceConsumption: balCons.toFixed(2),
          balanceTotal: (balMem + balCons).toFixed(2),

          contracts: contracts,
          comments: comments,

          checkins: [], // Placeholder
        }
      } catch (e) {
        console.error("Mapping Error:", e)
        return null
      }
    },

    // --- NAVIGATION ---
    goBack() {
      this.currentView = "search"
      this.selectedUser = null
      this.mappedData = null
      this.editUserData = null
      this.contracts = []
      this.transactions = []
    },

    // --- SEARCH ---
    async performSearch() {
      this.searching = true
      this.searchPerformed = true
      this.profileResults = []
      try {
        let res = await tacApi.searchTACProfiles(this.searchValues)
        if (res.Result.code === "183") {
          this.profileResults = []
        } else if (res.Profiles?.Profile) {
          // Ensure array
          let profiles = Array.isArray(res.Profiles.Profile) ? res.Profiles.Profile : [res.Profiles.Profile]
          this.profileResults = profiles.map((e) => (e.Profile.Profile ? e.Profile.Profile : e))
        }
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler bei der Suche")
      } finally {
        this.searching = false
      }
    },
    resetSearch() {
      this.searchValues = { FirstName: "", LastName: "", EMail: "", ProfileID: "" }
      this.profileResults = []
      this.searchPerformed = false
    },

    // --- USER HANDLING ---
    async selectUser(user) {
      this.selectedUser = user
      this.mappedData = null

      // Deep copy for editing
      this.editUserData = JSON.parse(JSON.stringify(user))
      this.ensureProfileStructure(this.editUserData)

      this.currentView = "details"
      this.activeTab = 0

      // Load RICH data
      const email = this.getEmailObj()?.PhoneData?.PhoneNumber
      if (email) {
        this.fetchRichMemberData(email)
        // Also check roody
        try {
          let rUser = await api.getUserForManagerByEmail(email)
          if (rUser && !rUser.status) this.roodyUser = rUser
          else this.roodyUser = null
        } catch (e) {
          this.roodyUser = null
        }
      } else {
        this.$toast.error("Keine E-Mail im Profil gefunden - Details eingeschränkt")
      }
    },

    async fetchRichMemberData(email) {
      this.loadingContracts = true
      this.loadingFinancials = true
      try {
        let res = await tacApi.fetchTACAllMembershipsByEmailAllData(email)
        if (res && res.userMembershipAllData) {
          this.mappedData = this.mapTacMemberData(res.userMembershipAllData)
          // Initialize comments
          this.loadCommentForType()
          // Fetch transactions
          this.fetchTransactionsForMappedData(res.userMembershipAllData)
        } else {
          this.$toast.warning("Keine detaillierten Mitgliedsdaten gefunden")
        }
      } catch (e) {
        console.error("Rich fetch failed", e)
        this.$toast.error("Fehler beim Laden der Details")
      } finally {
        this.loadingContracts = false
        this.loadingFinancials = false
      }
    },

    fetchTransactionsForMappedData(rawData) {
      try {
        const allDetails = this.ensureArray(rawData.MemberDetails.MemberDetail)
        let foundAcc = null
        for (let d of allDetails) {
          const accs = this.ensureArray(d.Accounts?.Account)
          foundAcc = accs.find((a) => a.type === "MEMBERSHIP" && a.AccountID?.UniqueID?.[0]?.value)
          if (foundAcc) break
        }

        if (foundAcc) {
          let accId = foundAcc.AccountID.UniqueID[0].value
          let from = moment().subtract(3, "years").format("YYYY-MM-DD")
          let to = moment().add(1, "months").format("YYYY-MM-DD")
          tacApi.fetchAccountTransactionsForID(accId, from, to).then((res) => {
            if (res?.AccountTransactions?.AccountTransactions) {
              this.transactions = res.AccountTransactions.AccountTransactions.map((t) => ({
                valutaDate: t.TransactionDate,
                description: t.AccountTransactionDetails?.AccountTransactionDetail?.[0]?.Description || "Keine Beschreibung",
                amount: parseFloat(t.Value?.value || 0),
              }))
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },

    loadCommentForType() {
      this.currentNoteText = ""
      if (!this.mappedData || !this.mappedData.comments) return

      let found = this.mappedData.comments.find((c) => c.type === this.currentNoteType)
      if (found) {
        this.currentNoteText = found.text
      }
    },

    getLastCommentDate() {
      if (!this.mappedData || !this.mappedData.comments) return "-"
      let found = this.mappedData.comments.find((c) => c.type === this.currentNoteType)
      return found && found.updateDate ? moment(found.updateDate).format("DD.MM.YYYY HH:mm") : "-"
    },

    async saveCurrentNote() {
      if (!this.selectedUser) return
      let tacId = this.getProfileID(this.selectedUser)
      if (!tacId) return

      this.savingComment = true
      try {
        await tacApi.createTACUserProfileComment({
          tacId: tacId,
          text: this.currentNoteText,
          type: this.currentNoteType,
        })
        this.$toast.success(`${this.currentNoteType} gespeichert`)
        // Refresh data
        const email = this.getEmailObj()?.PhoneData?.PhoneNumber
        if (email) this.fetchRichMemberData(email)
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.savingComment = false
      }
    },

    createNewUser() {
      // Init empty user structure
      this.editUserData = {
        Profile: {
          Customer: {
            PersonName: { FirstName: "", LastName: "", Salutation: "Herr" },
            gender: "MALE",
            birthDate: "",
            AccountName: "",
          },
          Addresses: { NameAddress: [] },
          Phones: { NamePhone: [] },
        },
      }
      this.ensureProfileStructure(this.editUserData.Profile)
      this.editUserData = this.editUserData.Profile

      this.selectedUser = null
      this.mappedData = null
      this.currentView = "details"
    },

    ensureProfileStructure(profile) {
      if (!profile.Phones) profile.Phones = { NamePhone: [] }
      if (!profile.Phones.NamePhone) profile.Phones.NamePhone = []

      if (!profile.Addresses) profile.Addresses = { NameAddress: [] }
      if (!profile.Addresses.NameAddress) profile.Addresses.NameAddress = []

      // Helpers to find/create specific entries
      const ensurePhone = (type) => {
        if (!profile.Phones.NamePhone.find((e) => e.phoneType === type)) {
          profile.Phones.NamePhone.push({
            phoneType: type,
            phoneRole: type === "EMAIL" ? "EMAIL" : "PHONE",
            PhoneData: { PhoneNumber: "" },
            primary: true,
            displaySequence: 1,
            deleted: false,
          })
        }
      }
      ensurePhone("EMAIL")
      ensurePhone("MOBILE")

      const ensureAddress = (type) => {
        if (!profile.Addresses.NameAddress.find((e) => e.addressType === type)) {
          profile.Addresses.NameAddress.push({
            addressType: type,
            AddressLine1: "",
            CityName: "",
            PostalCode: "",
            CountryCode: "CH",
            primary: true,
            displaySequence: 1,
            deleted: false,
          })
        }
      }
      ensureAddress("HOME")
    },

    // Form Accessors
    getEmailObj() {
      return this.editUserData.Phones.NamePhone.find((e) => e.phoneType === "EMAIL")
    },
    getMobileObj() {
      return this.editUserData.Phones.NamePhone.find((e) => e.phoneType === "MOBILE")
    },
    getAddressObj() {
      return this.editUserData.Addresses.NameAddress.find((e) => e.addressType === "HOME")
    },

    async saveProfile() {
      if (!this.$refs.profileForm.validate()) return
      this.savingProfile = true
      try {
        let request = {
          Profile: this.editUserData,
          ResortId: ["1"],
        }

        await tacApi.updateTACUserProfile(request)
        this.$toast.success("Profil gespeichert")

        if (!this.selectedUser) {
          this.goBack()
        }
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.savingProfile = false
      }
    },

    initiateTermination(contract) {
      this.showTerminationDialog = true
    },

    onTerminationCompleted() {
      this.showTerminationDialog = false
      const email = this.getEmailObj()?.PhoneData?.PhoneNumber
      if (email) this.fetchRichMemberData(email)
    },

    fetchFinancials() {
      // Re-trigger global fetch
      const email = this.getEmailObj()?.PhoneData?.PhoneNumber
      if (email) this.fetchRichMemberData(email)
    },

    // --- HELPERS ---
    getProfileID(user) {
      if (!user || !user.IDs || !user.IDs.UniqueID) return null
      return user.IDs.UniqueID.find((e) => e.source === "TAC")?.value || "-"
    },
    getAddressString(user) {
      if (!user.Addresses?.NameAddress) return "-"
      let home = user.Addresses.NameAddress.find((e) => e.addressType === "HOME")
      if (!home) return "-"
      return `${home.PostalCode} ${home.CityName}, ${home.AddressLine1}`
    },
    formatDate(dateStr) {
      if (!dateStr) return "-"
      return moment(dateStr).format("DD.MM.YYYY")
    },
    formatCurrency(val) {
      if (val === undefined || val === null) return "CHF 0.00"
      return `CHF ${parseFloat(val).toFixed(2)}`
    },
    mapUserForWizard(user) {
      let phoneObj = user.Phones?.NamePhone?.find((e) => e.phoneType === "MOBILE")
      let emailObj = user.Phones?.NamePhone?.find((e) => e.phoneType === "EMAIL")

      return {
        firstName: user.Customer.PersonName.FirstName,
        fullName: `${user.Customer.PersonName.FirstName} ${user.Customer.PersonName.LastName}`,
        email: emailObj ? emailObj.PhoneData.PhoneNumber : "",
        phone: phoneObj ? phoneObj.PhoneData.PhoneNumber : "",
      }
    },
  },
}
</script>
